import { useLazyQuery } from '@apollo/client';
import { Badge, Chip } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { WidgetCode } from 'component/popup/constant';
import WidgetPopup from 'component/popup/customize_popup';
import config from 'config';
import { STYLE_SUGGESTION } from 'graph_ql/search/style_suggestion';
import React, { HTMLProps, useEffect, useState } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
// import { Swiper, SwiperSlide } from 'swiper/react';

import {
    changeTriggerUpdateSearch,
    setBodyShapeFilter,
    setBodyTypeFilter,
    setCategoryFilter,
    setGenderFilter,
    resetFilter,
    setIsCategoryDefault,
    setSearchTerm,
    setShowFilter,
} from '../../redux/filter/filterSlice';
import { RootState, useAppDispatch, useAppSelector } from '../../redux/store';
import AutoCompleteSearch from './auto_complete_input';
import { useStyles } from './style';
import { useLocation } from 'react-router-dom';
import { PATH } from '../../routes/constant';
import { setSelectedStore } from '../../redux/create-style/create-style.slice';

interface IHeaderFilterProps extends HTMLProps<HTMLDivElement> {
    handler?: any;
    setInputSearch?: any;
    value?: any;
    disableSuggestions?: boolean;
}

function HeaderFilter(rest: IHeaderFilterProps) {
    const location = useLocation();
    const dispatch = useAppDispatch();
    const { selectedStore } = useAppSelector((state: RootState) => state.createStyle);
    const { handler, setInputSearch, value, disableSuggestions = false } = rest;
    const classes = useStyles();
    const [showPopup, setShowPopup] = useState(false);
    const [isShort, setIsShort] = useState(false);
    const [popupWidget, setPopupWidget] = useState<null | WidgetCode>(null);
    const [suggestions, setSuggestions] = useState<Array<string>>([]);
    const [popupTitle, setPopupTitle] = useState('Sort by');

    const [genderLabel, setGenderLabel] = useState<string>('Gender');
    const [activeGenderFilter, setActiveGenderFilter] = useState<boolean>(false);

    const [bodyShapeLabel, setBodyShapeLabel] = useState<string>('Body Shape');
    const [activeBodyShapeFilter, setActiveBodyShapeFilter] = useState<boolean>(false);

    const [bodyTypeLabel, setBodyTypeLabel] = useState<string>('Body Type');
    const [activeBodyTypeFilter, setActiveBodyTypeFilter] = useState<boolean>(false);

    const [categoryLabel, setCategoryLabel] = useState<string>('Category');
    const [activeCategoryFilter, setActiveCategoryFilter] = useState<boolean>(false);

    const [priceLabel, setPriceLabel] = useState<string>('Price');
    const [activePriceFilter, setActivePriceFilter] = useState<boolean>(false);

    const [brandsLabel, setBrandsLabel] = useState<string>('Brands');
    const [activeBrandsFilter, setActiveBrandsFilter] = useState<boolean>(false);

    const isStyleReview = location.pathname === PATH.STYLE_REVIEW;

    const [numOfFilter, setNumOfFilter] = useState<number>(0);

    const {
        genderFilterList,
        categoryFilterList,
        currentMinPrice,
        currentMaxPrice,
        currentSortType,
        showFilter,
        searchTerm,
        bodyShapeFilterList,
        bodyTypeFilterList,
        brandFilterList,
    } = useAppSelector((state: RootState) => state.filter);
    function handleLabel() {
        let countFilter = 0;
        if (currentMinPrice || currentMaxPrice) {
            countFilter += 1;
            setActivePriceFilter(true);
            if (currentMinPrice && currentMaxPrice) {
                setPriceLabel(`${currentMinPrice} - ${currentMaxPrice} SAR`);
            } else if (currentMinPrice) {
                setPriceLabel(`>= ${currentMinPrice} SAR`);
            } else if (currentMaxPrice) {
                setPriceLabel(`<= ${currentMaxPrice} SAR`);
            }
        } else {
            setActivePriceFilter(false);
            setPriceLabel('Price');
        }

        const activeGenderLabel = genderFilterList.reduce((label, item) => {
            const joinString = label === '' ? '' : ', ';
            if (item.isActive) {
                label += joinString + item.title;
            }
            return label;
        }, '');

        if (activeGenderLabel === '') {
            setGenderLabel('Gender');
            setActiveGenderFilter(false);
        } else {
            countFilter += 1;
            setGenderLabel(activeGenderLabel);
            setActiveGenderFilter(true);
        }

        const activeCategories = categoryFilterList.filter((item) => item.isActive);
        let activeCategoryLabel = '';

        if (activeCategories && activeCategories.length) {
            if (activeCategories.length > 2) {
                activeCategoryLabel = activeCategories[0].title + ', ' + activeCategories[1].title + ', ...';
            } else {
                activeCategoryLabel = activeCategories.map((i) => i.title).join(', ');
            }
        }

        if (activeCategoryLabel === '') {
            setCategoryLabel('Category');
            setActiveCategoryFilter(false);
        } else {
            countFilter += 1;
            setCategoryLabel(activeCategoryLabel);
            setActiveCategoryFilter(true);
        }

        const activeBodyShapeLabel = bodyShapeFilterList.reduce((label, item) => {
            const joinString = label === '' ? '' : ', ';
            if (item.isActive) {
                label += joinString + item.title;
            }
            return label;
        }, '');

        if (activeBodyShapeLabel === '') {
            setBodyShapeLabel('Body Shape');
            setActiveBodyShapeFilter(false);
        } else {
            countFilter += 1;
            setBodyShapeLabel(activeBodyShapeLabel);
            setActiveBodyShapeFilter(true);
        }

        const activeBodyTypeLabel = bodyTypeFilterList.reduce((label, item) => {
            const joinString = label === '' ? '' : ', ';
            if (item.isActive) {
                label += joinString + item.title;
            }
            return label;
        }, '');

        if (activeBodyTypeLabel === '') {
            setBodyTypeLabel('Body Type');
            setActiveBodyTypeFilter(false);
        } else {
            countFilter += 1;
            setBodyTypeLabel(activeBodyTypeLabel);
            setActiveBodyTypeFilter(true);
        }

        const activeBrandsLabel = brandFilterList?.reduce((label, item) => {
            const joinString = label === '' ? '' : ', ';
            if (item.isActive) {
                label += joinString + item.title;
            }
            return label;
        }, '');

        if (activeBrandsLabel === '') {
            setBrandsLabel('Brands');
            setActiveBrandsFilter(false);
        } else {
            countFilter += 1;
            setBrandsLabel(activeBrandsLabel);
            setActiveBrandsFilter(true);
        }

        if (location.pathname === PATH.STYLE_REVIEW && selectedStore) {
            countFilter += 1;
        }

        setNumOfFilter(countFilter > 0 ? countFilter : 0);
    }
    useEffect(() => {
        handleLabel();
        // eslint-disable-next-line
    }, [
        genderFilterList,
        currentMinPrice,
        currentMaxPrice,
        currentSortType,
        categoryFilterList,
        bodyShapeFilterList,
        bodyTypeFilterList,
        brandFilterList,
    ]);

    useEffect(() => {
        handleLabel();
        // eslint-disable-next-line
    }, []);

    const [getSuggestions] = useLazyQuery(STYLE_SUGGESTION, {
        onCompleted(response) {
            const tempHits = response?.locationsInRadius ? [...response?.locationsInRadius?.hits] : [];
            const tempSuggestions = tempHits.map((item) => item.query);
            setSuggestions(tempSuggestions);
        },
        onError(error) {
            console.error('get data Failed: ', error);
        },
    });

    const handleGetSuggestions = (input) => {
        getSuggestions({
            variables: {
                index: config.algolia.algolia_prefix + 'styles_query_suggestions',
                query: input,
                filters: ``,
                facets: [
                    'price',
                    'genders.value',
                    'categories.name',
                    'bodyShapes.title',
                    'bodyTypes.title',
                    'purposes.title',
                    'items.data.brand.name',
                ],
            },
        });
    };

    const handleFilterClick = (filterWidget) => {
        setIsShort(false);
        if (filterWidget === WidgetCode.CategoryFilterWidget) {
            setPopupTitle('Style Categories');
        }
        if (filterWidget === WidgetCode.GenderFilterWidget) {
            setPopupTitle('Gender');
        }
        if (filterWidget === WidgetCode.PriceRangeFilterWidget) {
            setPopupTitle('Price');
        }
        if (filterWidget === WidgetCode.BodyShapeFilterWidget) {
            setPopupTitle('Body Shape');
        }
        if (filterWidget === WidgetCode.BodyTypeFilterWidget) {
            setPopupTitle('Body Type');
        }
        if (filterWidget === WidgetCode.BrandsFilterWidget) {
            setPopupTitle('Brands');
        }
        setPopupWidget(filterWidget);
        setShowPopup(true);
    };

    const handleResetFilter = () => {
        const oldSearchTerm = searchTerm;
        dispatch(resetFilter());
        // keep search term on clicking reset filter
        dispatch(setSearchTerm(oldSearchTerm));
        dispatch(setShowFilter(true));
        dispatch(changeTriggerUpdateSearch(true));
        dispatch(setIsCategoryDefault(false));
        dispatch(
            setGenderFilter(
                genderFilterList.map((item) => {
                    return { ...item, isActive: false };
                }),
            ),
        );
        dispatch(
            setBodyShapeFilter(
                bodyShapeFilterList.map((item) => {
                    return { ...item, isActive: false };
                }),
            ),
        );
        dispatch(
            setBodyTypeFilter(
                bodyTypeFilterList.map((item) => {
                    return { ...item, isActive: false };
                }),
            ),
        );
        dispatch(
            setCategoryFilter(
                categoryFilterList.map((item) => {
                    return { ...item, isActive: false };
                }),
            ),
        );
        if (location.pathname === PATH.STYLE_REVIEW) {
            dispatch(setSelectedStore(null));
        }
    };

    useEffect(() => {
        handleGetSuggestions(value || '');
        //eslint-disable-next-line
    }, [value]);

    return (
        <React.Fragment>
            <div id="header-filter" className={classes.filterWrap}>
                <AutoCompleteSearch
                    setInputSearch={setInputSearch}
                    handler={handler}
                    value={value}
                    suggestions={disableSuggestions ? [] : suggestions}
                />
                {showFilter || location.pathname === PATH.STYLE_REVIEW ? (
                    <div className={classes.filter}>
                        <ScrollContainer className={classes.filterSwiperWrapper}>
                            {numOfFilter ? (
                                <div className={classes.firstFilterChipWrap}>
                                    <Chip
                                        classes={{
                                            outlined: classes.chipOutline,
                                            label: classes.chipLabelActive,
                                            icon: classes.chipIconActive,
                                        }}
                                        className={classes.chipActive}
                                        icon={<Badge className={classes.badgeFilter} badgeContent={numOfFilter} />}
                                        label={'Clear Filters'}
                                        variant="outlined"
                                        onClick={handleResetFilter}
                                    />
                                </div>
                            ) : null}
                            {isStyleReview ? (
                                <div className={classes.filterChipWrap}>
                                    <Chip
                                        classes={{
                                            outlined: classes.chipOutline,
                                            label: selectedStore ? classes.chipLabelActive : classes.chipLabel,
                                            icon: selectedStore ? classes.chipIconActive : classes.chipIcon,
                                        }}
                                        className={selectedStore ? classes.chipActive : ''}
                                        icon={<ExpandMoreIcon />}
                                        label={selectedStore ? selectedStore.name : 'Store'}
                                        variant="outlined"
                                        onClick={() => {
                                            setIsShort(false);
                                            setPopupWidget(WidgetCode.SearchStoreWidget);
                                            setPopupTitle('Filter by Store');
                                            setShowPopup(true);
                                        }}
                                    />
                                </div>
                            ) : null}
                            <div className={classes.filterChipWrap}>
                                <Chip
                                    classes={{
                                        outlined: classes.chipOutline,
                                        label: activeGenderFilter ? classes.chipLabelActive : classes.chipLabel,
                                        icon: activeGenderFilter ? classes.chipIconActive : classes.chipIcon,
                                    }}
                                    className={activeGenderFilter ? classes.chipActive : ''}
                                    icon={<ExpandMoreIcon />}
                                    label={genderLabel}
                                    variant="outlined"
                                    onClick={() => handleFilterClick(WidgetCode.GenderFilterWidget)}
                                />
                            </div>
                            {!isStyleReview ? (
                                <>
                                    <div className={classes.filterChipWrap}>
                                        <Chip
                                            classes={{
                                                outlined: classes.chipOutline,
                                                label: activeBodyShapeFilter
                                                    ? classes.chipLabelActive
                                                    : classes.chipLabel,
                                                icon: activeBodyShapeFilter ? classes.chipIconActive : classes.chipIcon,
                                            }}
                                            className={activeBodyShapeFilter ? classes.chipActive : ''}
                                            icon={<ExpandMoreIcon />}
                                            label={bodyShapeLabel}
                                            variant="outlined"
                                            onClick={() => handleFilterClick(WidgetCode.BodyShapeFilterWidget)}
                                        />
                                    </div>
                                    <div className={classes.filterChipWrap}>
                                        <Chip
                                            classes={{
                                                outlined: classes.chipOutline,
                                                label: activeBodyTypeFilter
                                                    ? classes.chipLabelActive
                                                    : classes.chipLabel,
                                                icon: activeBodyTypeFilter ? classes.chipIconActive : classes.chipIcon,
                                            }}
                                            className={activeBodyTypeFilter ? classes.chipActive : ''}
                                            icon={<ExpandMoreIcon />}
                                            label={bodyTypeLabel}
                                            variant="outlined"
                                            onClick={() => handleFilterClick(WidgetCode.BodyTypeFilterWidget)}
                                        />
                                    </div>
                                    <div className={classes.filterChipWrap}>
                                        <Chip
                                            classes={{
                                                outlined: classes.chipOutline,
                                                label: activePriceFilter ? classes.chipLabelActive : classes.chipLabel,
                                                icon: activePriceFilter ? classes.chipIconActive : classes.chipIcon,
                                            }}
                                            className={activePriceFilter ? classes.chipActive : ''}
                                            icon={<ExpandMoreIcon />}
                                            label={priceLabel}
                                            variant="outlined"
                                            onClick={() => handleFilterClick(WidgetCode.PriceRangeFilterWidget)}
                                        />
                                    </div>
                                    <div className={classes.filterChipWrap}>
                                        <Chip
                                            classes={{
                                                outlined: classes.chipOutline,
                                                label: activeCategoryFilter
                                                    ? classes.chipLabelActive
                                                    : classes.chipLabel,
                                                icon: activeCategoryFilter ? classes.chipIconActive : classes.chipIcon,
                                            }}
                                            className={activeCategoryFilter ? classes.chipActive : ''}
                                            icon={<ExpandMoreIcon />}
                                            label={categoryLabel}
                                            variant="outlined"
                                            onClick={() => handleFilterClick(WidgetCode.CategoryFilterWidget)}
                                        />
                                    </div>
                                    <div className={classes.filterChipWrap}>
                                        <Chip
                                            classes={{
                                                outlined: classes.chipOutline,
                                                label: activeBrandsFilter ? classes.chipLabelActive : classes.chipLabel,
                                                icon: activeBrandsFilter ? classes.chipIconActive : classes.chipIcon,
                                            }}
                                            className={activeBrandsFilter ? classes.chipActive : ''}
                                            icon={<ExpandMoreIcon />}
                                            label={brandsLabel}
                                            variant="outlined"
                                            onClick={() => handleFilterClick(WidgetCode.BrandsFilterWidget)}
                                        />
                                    </div>
                                </>
                            ) : null}
                        </ScrollContainer>
                    </div>
                ) : null}
            </div>
            {showPopup && (
                <WidgetPopup
                    titlePopup={popupTitle}
                    widgetCode={popupWidget}
                    listItem={[]}
                    onClose={() => setShowPopup(false)}
                    shortPopup={isShort}
                />
            )}
        </React.Fragment>
    );
}

export default HeaderFilter;
